import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedERoutes = ({children}) =>{
    const auth = localStorage.getItem('able-auctions');

    if(!auth){
        return <Navigate to="/login" replace/>
    }
    return children
}

export default ProtectedERoutes

